<div class="headline-container">
  <span class="headline">
    {{ 'home.paycards.overview.title' | translate }}
    <span *ngIf="(paycards$ | async) as p">
      ({{ p.totalElements }})
    </span>
  </span>
  <div class="controls">
    <select class="select" (change)="onPaycardStatusChange($event.target.value)">
      <option [value]="''" [selected]="paycardStatus === null">{{ 'home.paycards.overview.status' | translate }}</option>
      <option *ngFor="let e of paycardStatusEnum" [value]="e" [selected]="paycardStatus === e">{{ e }}</option>
    </select>
    <input type="text" class="input small-input" [placeholder]="'home.paycards.overview.search' | translate" (input)="onPaycardFilterChange($event.target.value)">
  </div>
</div>
<ng-container *ngIf="(paycards$ | async) as paycards">
  <app-paycards-overview-table
    class="overview-table"
    [paycards]="paycards.content"
    (openDetails)="onOpenDetails($event)"
  ></app-paycards-overview-table>
  <app-pagination
    [page]="paycards.number + 1"
    [size]="paycards.size"
    [totalElements]="paycards.totalElements"
    (pageSelected)="onPageSelected($event - 1)"
    (sizeSelected)="onSizeSelected($event)"
  ></app-pagination>
</ng-container>

